module.exports = __webpack_public_path__ + "img/book.2d9222e2.png";